import {
  REEL_LIST_ATTEMPT,
  REEL_LIST_SUCCESS,
  REEL_LIST_FAILED,
  REEL_DELETE_SUCCESS,
} from "../types/reelTypes";

const INITIAL_STATE = {
  list: [],
  loading: false,
  error: "",
};

function reel(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REEL_LIST_ATTEMPT:
      return { ...state, loading: true, error: "" };

    case REEL_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.data.list || [],
        error: "",
      };

    case REEL_LIST_FAILED:
      return { ...state, loading: false, error: action.error, list: [] };

    case REEL_DELETE_SUCCESS:
      return {
        ...state,
        list: state.list.filter(
          (item) => String(item.Id) !== String(action.id)
        ),
      };

    default:
      return state;
  }
}

export default reel;
